import paper from 'paper';

export const isSystemItem = (item) =>
  Boolean(item?.guide || item?.data?.isGuide || item?.data?.isSystemOverlay);

export const clearSelection = () => {
  if (!paper.project) return;

  paper.project.selectedItems.forEach((item) => {
    if (!isSystemItem(item)) {
      item.selected = false;
    }
  });
};

export const drawGrid = () => {
  if (!paper.project) return;
  ['grid', 'glassArea'].forEach((name) => {
    const legacyItem = paper.project.getItem({name});
    if (legacyItem) legacyItem.remove();
  });
};